import { hasItem, toggleItem, onWishlistChange } from '@theme/wishlist-store';

// <s-wishlist-button> toggles one product handle in the local wishlist and mirrors state via aria-pressed.
class SWishlistButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const handle = this.dataset.handle;
    if (!handle) return;

    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      toggleItem(handle);
      const button = this.querySelector('button');
      if (button && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        button.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.2)' }, { transform: 'scale(1)' }], { duration: 300, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
      }
    }, { signal });

    onWishlistChange(() => this.#sync(), signal);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const button = this.querySelector('button');
    if (!button) return;
    const saved = hasItem(this.dataset.handle);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', saved ? this.dataset.removeLabel : this.dataset.addLabel);
  }
}

if (!customElements.get('s-wishlist-button')) customElements.define('s-wishlist-button', SWishlistButton);
